import React from 'react';
import { drapcodeIcon, iconForField } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';

const renderCTA = (ctaOnClick, ctaTitle, ctaText) => {
  return (
    <a onClick={ctaOnClick} className="direction-custom-link btn btn-outline-info" title={ctaTitle}>
      <i className="wb webconnect-box-arrow-up-right"></i>&nbsp;{ctaText}
    </a>
  );
};

export const renderInfoIcon = (label, description) => {
  return (
    description && (
      <TooltipInfo
        title={description}
        headerText={`What's ${label || 'this'}?`}
        showHeader={true}
        showArrow={true}
        append={true}
      />
    )
  );
};

export const renderRequiredSpan = () => {
  return <span className="required">&nbsp;*</span>;
};

const FormFieldWithLabel = ({
  cta = false,
  ctaOnClick,
  ctaTitle = '',
  ctaText = '',
  label,
  labelStyle = { fontSize: '14px' },
  icon = 'text',
  infoIcon = false,
  infoDescription = '',
  isRequired = false,
  children,
}) => {
  return (
    <>
      <div className="col-12">
        <span className="label text-muted" style={labelStyle}>
          {label}
        </span>
        {cta && renderCTA(ctaOnClick, ctaTitle, ctaText)}
      </div>
      <div className="col-12">
        <div className="input-group">
          <div className="input-group-prepend" title={label}>
            {icon == 'http' || icon == 'https' ? (
              <span className="input-group-text" style={{ backgroundColor: '#e9ecef' }}>
                {`${icon}://`}
                {isRequired && renderRequiredSpan()}
              </span>
            ) : (
              <span className="input-group-text">
                <i className={`wb ${iconForField(icon)}`}></i>
                {isRequired && renderRequiredSpan()}
              </span>
            )}
          </div>
          {children}
          {infoIcon && infoDescription && renderInfoIcon(label, infoDescription)}
        </div>
      </div>
    </>
  );
};

export default FormFieldWithLabel;
